(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/objects/scBlock/types/frs-donation/components/payment/partials/payment', '<div class="donation-table">\n' + '  <div class="donation-table_label">\n' + '    <label class="donation-label required"> {{ API.getPaymentLabel() }} </label>\n' + '  </div>\n' + '\n' + '  <div class="donation-table_row"></div>\n' + '</div>\n' + '');
}]);
})();